import { Check } from "lucide-react";

// Pemilih peringkat umur (pilihan berganda). Senarai kosong = semua peringkat umur.
export default function AgeRangePicker({ options, value, onChange, testIdPrefix = "age-pick" }) {
  const allSelected = value.length === 0;

  const toggle = (age) => {
    if (value.includes(age)) {
      onChange(value.filter((a) => a !== age));
    } else {
      const next = [...value, age];
      // Jika semua dipilih satu persatu, kembali ke "Semua"
      onChange(next.length === options.length ? [] : options.filter((o) => next.includes(o)));
    }
  };

  const chip = (active) =>
    `inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium border transition-colors duration-150 ${
      active
        ? "bg-purple-600 border-purple-600 text-white shadow-sm"
        : "bg-white border-gray-200 text-gray-600 hover:border-purple-300 hover:text-purple-700"
    }`;

  return (
    <div className="flex flex-wrap gap-2" data-testid={`${testIdPrefix}-list`}>
      <button type="button" data-testid={`${testIdPrefix}-all`} onClick={() => onChange([])} className={chip(allSelected)}>
        {allSelected && <Check className="w-3.5 h-3.5" />}
        Semua
      </button>
      {options.map((age) => {
        const active = value.includes(age);
        return (
          <button
            type="button"
            key={age}
            data-testid={`${testIdPrefix}-${age.replace(/\s+/g, "-")}`}
            onClick={() => toggle(age)}
            className={chip(active)}
          >
            {active && <Check className="w-3.5 h-3.5" />}
            {age}
          </button>
        );
      })}
    </div>
  );
}
